// extracted by mini-css-extract-plugin
export default {"android":"ARecommend_android__xlydw"};